import BottomSheet from "../common/BottomSheet";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import useTranslate from "../../hooks/useTranslate";
import LawyerCard from "./LawyerCard";
import { CloseIcon } from "./v2/icons";
import { LAW_SCRIM } from "./v2/tokens";

// "Preview my card" — Lawyers V2 follow-up A3 (FOLLOWUP-PACK-BRIEF /
// FUNCTION-TODO row 8, C27). Shows the lawyer's OWN directory card exactly as
// clubs see it by rendering the SAME LawyerCard component the directory grid
// uses — no clone, no re-implementation.
//
// Read-only by construction:
//   - no onContact/onView/isSelf props are passed, so the card's CTA and
//     click handlers are inert no-ops;
//   - pointer-events are disabled on the wrapper as a second guard;
//   - nothing is fetched and nothing is mutated here — the caller supplies
//     the card data from the ALREADY-LOADED own profile + live form state
//     (see LawyerProfileSettings), so no directory queries happen.
//
// Surface pattern per the platform's existing lawyer surfaces
// (ContactLawyerModal): desktop = centered modal on LAW_SCRIM, mobile
// (max-width 768px) = shared common/BottomSheet.
const LawyerCardPreview = ({ lawyer, onClose, t: tProp }) => {
  const { t: tHook } = useTranslate();
  const t = tProp || tHook;
  const isMobile = useMediaQuery("(max-width: 768px)");

  if (!lawyer) return null;

  const body = (
    <>
      <p className="text-[12px] text-[#667085] mb-[12px]">
        {t("This is how your card appears in the Lawyers directory.")}
      </p>
      {/* Directory canvas behind the card (#F5F7FB) so the preview reads like
          the real grid tile. */}
      <div
        className="bg-[#F5F7FB] rounded-[12px] p-[14px] pointer-events-none"
        data-testid="lawyer-card-preview"
      >
        <LawyerCard lawyer={lawyer} />
      </div>
    </>
  );

  // ── Mobile — shared bottom sheet (platform pattern, board-1n breakpoint) ──
  if (isMobile) {
    return (
      <BottomSheet open onClose={onClose} title={t("Card preview")}>
        <div className="pb-4">{body}</div>
      </BottomSheet>
    );
  }

  // ── Desktop — centered modal (ContactLawyerModal geometry) ──
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="absolute inset-0"
        style={{ background: LAW_SCRIM.modal }}
        onClick={onClose}
      />
      <div className="relative bg-white rounded-[16px] shadow-[0_20px_60px_rgba(16,24,40,0.25)] w-full max-w-[440px] p-6">
        <div className="flex items-start justify-between mb-1">
          <h3 className="text-[15.5px] font-bold text-[#101828]">
            {t("Card preview")}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="mt-[2px] text-[#667085] hover:text-[#101828] cursor-pointer flex-none"
            aria-label={t("Close")}
          >
            <CloseIcon size={15} />
          </button>
        </div>
        {body}
      </div>
    </div>
  );
};

export default LawyerCardPreview;
